import type { TransformRow } from './types';

export function rowsHaveColumn(
  rows: readonly TransformRow[],
  column: string,
): boolean {
  return rows.some((row) => Object.prototype.hasOwnProperty.call(row, column));
}

export function rowsHaveAllColumns(
  rows: readonly TransformRow[],
  columns: readonly string[],
): boolean {
  return columns.every((column) => rowsHaveColumn(rows, column));
}
